/*** IMPORTS FROM imports-loader ***/
var global = window;

var trim = require('./trim');

module.exports = function clean(str) {
  return trim(str).replace(/\s\s+/g, ' ');
};

